// extracted by mini-css-extract-plugin
module.exports = {"loader":"BlogLoader_loader__8ZYWE","titleLoader":"BlogLoader_titleLoader__XA7vg"};